/**
 * @desc 导入军团信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/corpsInfo/import`, {
      method: "POST",

      ...options,
    }),
  );
}
